/**
 * Smithing table transforms (vanilla smithing_transform): netherite upgrade
 * template + diamond gear + netherite ingot -> the netherite piece, keeping
 * damage, enchantments and anvil work. Armor trims are not implemented.
 */

import { I, itemNameOf } from './itemIds';
import { cloneStack, isEmpty, type Stack } from './types';

/** Result of the three smithing inputs, or null. */
export function smithResult(template: Stack, base: Stack, addition: Stack): Stack | null {
  if (isEmpty(template) || isEmpty(base) || isEmpty(addition)) return null;
  if (template.id !== I.NETHERITE_UPGRADE_SMITHING_TEMPLATE || addition.id !== I.NETHERITE_INGOT) return null;
  const n = itemNameOf(base.id);
  if (!n || !n.startsWith('DIAMOND_')) return null; // incl. DIAMOND_SPEAR -> NETHERITE_SPEAR
  const target = (I as Record<string, number>)[n.replace('DIAMOND_', 'NETHERITE_')];
  if (!target) return null;
  const out = cloneStack(base);
  out.id = target;
  out.count = 1;
  return out;
}
